<template>
  <modal
    ref="addDevice"
    :ok-disabled="loading"
    :ok-title="!$parent.edit ? 'Pridať' : 'Upraviť'"
    :title="!$parent.edit ? 'Pridať prístroj' : 'Upraviť prístroj'"
    cancel-title="Zrušiť"
    full-height
    name="add-device"
    scrollable
    size="md"
    type="from-right"
    @hidden="Object.assign($data, $options.data())"
    @ok="$parent.saveDevice"
    @show="fetchData"
  >
    <b-overlay :blur="null" :show="loading" class="h-100" opacity="0">
      <transition mode="out-in" name="fadeShort">
        <div v-if="!loading" ref="scroll" v-bar>
          <div>
            <b-form-group
              label-cols-sm="5"
              label="Sériové číslo elektromera"
              label-for="serialNumber"
            >
              <b-form-input
                v-model="form.serialNumber"
                v-validate="'required'"
                :class="{ 'is-invalid': errors.has('serialNumber') }"
                data-vv-as="Sériové číslo elektromera"
                name="serialNumber"
              />
              <b-form-invalid-feedback>
                {{ errors.first('serialNumber') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              label-cols-sm="5"
              label="Materiálové číslo"
              label-for="materialNumber"
            >
              <b-form-input
                v-model="form.materialNumber"
                name="materialNumber"
              />
            </b-form-group>
            <b-form-group
              label-cols-sm="5"
              label="Koeficient zúčtovania"
              label-for="totalCoef"
            >
              <vue-autonumeric
                v-model="form.totalCoef"
                class="form-control"
                name="totalCoef"
              />
            </b-form-group>
            <b-form-group
              label-cols-sm="5"
              label="Dátum od"
              label-for="dateFrom"
            >
              <single-date
                v-model="form.dateFrom"
                class="form-control"
                name="dateFrom"
              />
            </b-form-group>
            <b-form-group label-cols-sm="5" label="Dátum do" label-for="dateTo">
              <single-date
                v-model="form.dateTo"
                class="form-control"
                name="dateTo"
              />
            </b-form-group>
          </div>
        </div>
      </transition>
    </b-overlay>
  </modal>
</template>
<script>
import Modal from '@/components/Modal'
import SingleDate from '@/components/inputs/SingleDate'
import { mapState } from 'vuex'

export default {
  components: {
    Modal,
    SingleDate,
  },
  data() {
    return {
      loading: false,
      attributes: [],
      form: {},
    }
  },
  computed: {
    ...mapState({
      energetic: (state) => state.energetic.current.data,
    }),
  },
  methods: {
    fetchData() {
      this.form = {
        energetics_id: parseInt(this.$route.params.energetics_id),
      }
      if (this.$parent.edit) {
        this.loading = true
      }
      this.axios
        .all([
          this.$api.get('attributes/get', {
            params: {
              select: 'energetic_contracts',
            },
          }),
          this.$parent.edit
            ? this.$api.get(`energetics/${this.$parent.id}/device/get_form`)
            : '',
        ])
        .then(
          this.axios.spread((attr, formdata) => {
            this.attributes = attr.data
            if (this.$parent.edit) {
              this.form = formdata.data.data
            }
            this.loading = false
          }),
        )
    },
  },
}
</script>
